import type { FreeTextStaticContent } from '@core-api/presentation/types/response';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { FreeTextPresentation } from './FreeTextPresentation';

export function FreeTextPresentationDataHandler() {
  const { useConfig, InteractiveCanvasComponents } = usePresentationContext();
  const { enableAnimations } = useConfig();

  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as FreeTextStaticContent;

  return (
    <FreeTextPresentation
      styledBody={staticContent.styledBody as Record<string, unknown>}
      textAlignment={staticContent.textAlignment}
      shouldAnimate={enableAnimations}
      CanvasTitleArea={InteractiveCanvasComponents?.CanvasTitleArea}
      CanvasBodyArea={InteractiveCanvasComponents?.Body}
    />
  );
}
